// extracted by mini-css-extract-plugin
export var close = "CookieBar-module--close--241be";
export var container = "CookieBar-module--container--0d9a1";
export var message = "CookieBar-module--message--ab748";